// FY27 tentpole events whose national feeds (US National, CA National,
// CA National (FR)) are entirely NHL Sales inventory, including In-Ice and
// Center Circle (request from NHL, 2026-10-12). Club users get no editable
// slots on these feeds; NHL users keep full access.
//
// Keep in sync with the copy in statistics-handler/data.mjs and with
// migrations/V28 and V37, which set the DED share models of these Outputs.
export const NHL_SALES_NATIONAL_EVENT_IDS = Object.freeze([
  2026020182, // MTL @ WPG, 2026-10-25
  2026020647, // COL @ UTA, 2026-12-31
  2026020974, // VGK @ DAL, 2027-02-20
]);

const NHL_SALES_NATIONAL_OUTPUT_NAMES = Object.freeze([
  'US National',
  'CA National',
  'CA National (FR)',
]);

export const isNhlSalesEvent = eventId =>
  NHL_SALES_NATIONAL_EVENT_IDS.includes(Number(eventId));

export const isNhlSalesNationalFeed = (eventId, outputName) =>
  isNhlSalesEvent(eventId) &&
  NHL_SALES_NATIONAL_OUTPUT_NAMES.includes(String(outputName || '').trim());

// DED share model of an NHL Sales national feed; null for every other Output.
export const getNhlSalesNationalShareModel = (eventId, outputName) => {
  if (!isNhlSalesNationalFeed(eventId, outputName)) return null;
  return String(outputName).trim() === 'US National' ? 'RS-USA-N-2' : 'RS-CDN-N-5';
};

// Club Playlist Wizard targets (each carries its eventId). An In-Ice or Center
// Circle save into any feed of an NHL Sales event would also mirror into its
// NHL-only national feeds, so those events are not offered as targets.
export const withoutNhlSalesWizardTargets = (targets, playlistType) =>
  ['II', 'CCZ'].includes(playlistType)
    ? targets.filter(target => !isNhlSalesEvent(target?.eventId))
    : targets;
